import { Button, Form, Offcanvas } from "react-bootstrap";
import { TagsFill } from "react-bootstrap-icons";
import { useTranslation } from 'react-i18next';

function FavouriteGameEditor(props) {
    const { t } = useTranslation('messages');

    if (!props.showEditGame) return null;

    return (
        <Offcanvas show={props.showEditGame} onHide={props.onCloseGameEditor} placement="bottom">
            <Offcanvas.Header closeButton className="border-bottom" data-bs-theme="dark"
                style={{ backgroundColor: '#2d1b4e', color: '#fff' }}>
                <Offcanvas.Title className="fw-semibold">{props.underEditGame.name}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body style={{ backgroundColor: '#fdf4ff' }}>
                <Form onSubmit={(e) => onAssociateLabels(e, props.associateLabels, props.underEditGame.favouriteGameId, props.underAssociationLabelsMap, props.onCloseGameEditor)}>
                    <div className="mb-4">
                        {props.gameLabels.map((gameLabel) => (
                            <Form.Check
                                key={gameLabel.gameLabelId}
                                type="checkbox"
                                label={gameLabel.name}
                                className="mb-2"
                                defaultChecked={props.underAssociationLabelsMap.get(gameLabel.gameLabelId)}
                                onClick={(e) => {
                                    let newMap = new Map(props.underAssociationLabelsMap);
                                    newMap.set(gameLabel.gameLabelId, e.target.checked);
                                    props.setUnderAssociationLabelsMap(newMap);
                                }}
                            />
                        ))}
                    </div>
                    <Button type="submit" className="fw-semibold"
                        style={{ backgroundColor: '#6d28d9', borderColor: '#6d28d9', color: '#fff' }}>
                        <TagsFill size={14} className="me-2" />
                        {t('private_area.games_tab.games_associate_labels_button_text')}
                    </Button>
                </Form>
            </Offcanvas.Body>
        </Offcanvas>
    );
}

function onAssociateLabels(e, associateLabels, gameId, underAssociationLabelsMap, onCloseGameEditor) {
    e.preventDefault();

    let gameLabelIds = [];

    for (let [gameId, checked] of underAssociationLabelsMap.entries()) {
        if (checked) {
            gameLabelIds.push(gameId);
        }
    }

    associateLabels(gameId, gameLabelIds);
    onCloseGameEditor();
}

export default FavouriteGameEditor;